export const getQuestionScore = function (chosenAnswers) {
	const slide = this.state.slides[this.state.position];
	let score = 0;
	if (Array.isArray(chosenAnswers)) {
		chosenAnswers.forEach((answerKey) => {
			score += slide.answers[answerKey].value;
		});
	} else {
		score = slide.answers[chosenAnswers].value;
	}
	return score;
};

export const calcUserScore = function () {
	const state = this.state;

	// Only recalculate score if question is inside a dimension that is included in the total score
	if (state.dimensions[state.slides[state.position].dimension].include_in_score) {
		this.calcDimensionScore(this.calcTotalScore);
	}
};

export const calcDimensionScore = function (callback) {
	const d = this.state.slides[this.state.position].dimension;
	const dimensionResults = { ...this.state.userData.dimensions[d].results };

	// Only calculate score of dimension if all its questions are answered
	if (Object.keys(dimensionResults).length === this.state.dimensions[d].question_count) {
		let pointsInDimension = 0;
		for (let i in dimensionResults) {
			pointsInDimension += dimensionResults[i].score;
		}

		// Calculate final score as ratio
		const dimensionScore = Math.round((pointsInDimension / this.state.dimensions[d].max_score) * 100);

		this.setState(
			{
				userData: {
					...this.state.userData,
					dimensions: { ...this.state.userData.dimensions, [d]: { ...this.state.userData.dimensions[d], score: dimensionScore } },
				},
			},
			callback,
		);

		// Remove dimension score and total score if not all questions in the dimension are answered
	} else {
		this.setState({
			userData: {
				...this.state.userData,
				dimensions: { ...this.state.userData.dimensions, [d]: { ...this.state.userData.dimensions[d], score: false } },
				score: false,
			},
		});
	}
};

export const calcTotalScore = function () {
	const dimensions = this.state.dimensions;
	let dimensionScores = [];
	let score = false;

	for (let d in dimensions) {
		// Check if dimension should be included for total score calculation
		if (dimensions[d].include_in_score) {
			// Check if dimension exists in user data and has a valid score, otherwise reset score to false
			if (d in this.state.userData.dimensions && this.state.userData.dimensions[d].score !== false) {
				dimensionScores.push(this.state.userData.dimensions[d].score);
			} else {
				dimensionScores = [];
				break;
			}
		}
	}

	if (dimensionScores.length) {
		score = Math.round(
			dimensionScores.reduce((previousValue, currentValue) => {
				return previousValue + currentValue;
			}) / dimensionScores.length,
		);
	}

	this.setState({
		userData: {
			...this.state.userData,
			score: score,
		},
	});
};
